import { useEffect, useState } from 'react'

import Collapse from '@mui/material/Collapse'

import type { GeblokkeerdeWeek } from '../../planning/types/GeblokkeerdeWeek'
import { StyledAlert } from '../../theme/components/StyledAlert'

type Props = {
  geblokkeerdeWeken: GeblokkeerdeWeek[]
  isoWeek?: string
  gebiedscode: string
}

export const GeblokkeerdeWekenWarning = ({
  geblokkeerdeWeken,
  isoWeek = '',
  gebiedscode,
}: Props) => {
  const selectedGeblokkeerdeWeek = isoWeek
    ? geblokkeerdeWeken.find((geblokkeerdeWeek) => {
        return (
          geblokkeerdeWeek.week === isoWeek &&
          geblokkeerdeWeek.gebiedscode === gebiedscode
        )
      })
    : undefined

  const [warningWeek, setWarningWeek] = useState<GeblokkeerdeWeek | null>(null)
  useEffect(() => {
    if (selectedGeblokkeerdeWeek) {
      setWarningWeek(selectedGeblokkeerdeWeek)
    }
  }, [selectedGeblokkeerdeWeek])

  return (
    <Collapse in={Boolean(selectedGeblokkeerdeWeek)} unmountOnExit>
      <StyledAlert severity="warning" title="Let op!">
        {`De geselecteerde week is geblokkeerd door ${warningWeek?.organisatie} in gebied ${warningWeek?.gebiedscodeLabel}.`}
      </StyledAlert>
    </Collapse>
  )
}
